import toast, { Toaster } from "react-hot-toast";

function RootResultRow(props: any) {

    function handleClickDelete() {
        fetch("" + process.env.REACT_APP_API_URL + "/admin/delete?id=" + props.id, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then((res) => {
                if (!res.ok) { throw new Error(`Erreur HTTP : ${res.status}`) }
                else {
                    props.setResult(
                        props.result.filter((elem: any) => {
                            return elem.id !== props.id;
                        })
                    );
                }

            })
            .catch((e) => console.log(e.message))
    }


    function handleClickPromote() {
        let action = props.role === 'ADMIN' ? "promote-admin" : "promote-user";
        fetch("" + process.env.REACT_APP_API_URL + "/root/" + action, {
            method: "POST",
            body: JSON.stringify({
                id: props.id,
            }),
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then((res) => {
                if (!res.ok) {
                    toast.error("Cannot promote further.")
                    throw new Error(`Erreur HTTP : ${res.status}`);
                }
                else {
                    console.log("pwt");
                    toast.success("Promote successfull.");
                    props.forcedRefresh();
                }

            })
            .catch((e) => console.log(e.message))
    }

    function handleClickDemote() {
        if (sessionStorage.getItem("id") == props.id) {
            toast.error("Cannot demote yourself.");
            return;
        }


        let action = props.role === 'ADMIN' ? "demote-admin" : "demote-root";
        fetch("" + process.env.REACT_APP_API_URL + "/root/" + action, {
            method: "POST",
            body: JSON.stringify({
                id: props.id
            }),
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then((res) => {
                if (!res.ok) {
                    toast.error("Cannot demote further.");
                    throw new Error(`Erreur HTTP : ${res.status}`);
                }
                else {
                    toast.success("Demote successfull.");
                    props.forcedRefresh();
                }

            })
            .catch((e) => console.log(e.message))
    }


    return (

        <tr>

            <td>{props.id}</td>

            <td>{props.login}</td>
            <td>
                <button onClick={() => {
                    handleClickDelete();
                }} >DEL</button>
            </td>
            <td>{props.role}</td>
            <td><button onClick={() => {
                handleClickPromote();
            }}>++</button></td>
            <td><button onClick={() => {
                handleClickDemote();
            }}>--</button></td>
        </tr>



    );


}

export default RootResultRow;